export default __webpack_public_path__ + "static/media/85.48d05495.svg";